module.exports = __webpack_public_path__ + "static/media/Q10-3.b9966b75.png";